import { useRef, useState } from "react";

export default function ShareRow({ title }: { title: string }) {
  const [notice, setNotice] = useState("");
  const timerRef = useRef<number | null>(null);

  const showNotice = (message: string) => {
    setNotice(message);
    if (timerRef.current) window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => setNotice(""), 5000);
  };

  const handleDemoShare = (platform: string) => {
    showNotice(`${platform}分享为前端演示，未接入真实分享接口。你可以复制链接后前往${platform}手动分享。`);
  };

  const handleCopy = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      showNotice("链接已复制到剪贴板，可直接粘贴分享。");
    } catch {
      showNotice("当前浏览器未授权剪贴板访问，请从地址栏手动复制页面链接。");
    }
  };

  return (
    <div className="rounded-lg border border-background-200 bg-background-100 p-4">
      <p className="text-xs font-semibold uppercase tracking-wider text-foreground-500">分享这部剧</p>
      <div className="mt-3 grid grid-cols-3 gap-2">
        <button
          type="button"
          onClick={() => handleDemoShare("微博")}
          className="flex flex-col items-center justify-center gap-1.5 rounded-md border border-background-300 bg-background-50 py-3 text-xs text-foreground-600 transition-colors hover:border-accent-300 hover:text-accent-700"
          aria-label={`分享${title}到微博（演示）`}
        >
          <i className="ri-weibo-fill text-lg" aria-hidden="true" />
          微博
        </button>
        <button
          type="button"
          onClick={() => handleDemoShare("微信")}
          className="flex flex-col items-center justify-center gap-1.5 rounded-md border border-background-300 bg-background-50 py-3 text-xs text-foreground-600 transition-colors hover:border-accent-300 hover:text-accent-700"
          aria-label={`分享${title}到微信（演示）`}
        >
          <i className="ri-wechat-fill text-lg" aria-hidden="true" />
          微信
        </button>
        <button
          type="button"
          onClick={handleCopy}
          className="flex flex-col items-center justify-center gap-1.5 rounded-md border border-background-300 bg-background-50 py-3 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
          aria-label="复制页面链接"
        >
          <i className="ri-link-m text-lg" aria-hidden="true" />
          复制链接
        </button>
      </div>
      <p className="mt-3 flex items-start gap-1.5 text-[11px] leading-5 text-foreground-400">
        <i className="ri-information-line mt-0.5 text-sm" aria-hidden="true" />
        分享功能仅作展示，不会向第三方平台发送任何数据。
      </p>
      {notice && (
        <p
          role="status"
          aria-live="polite"
          className="mt-3 animate-fade-in rounded-md bg-accent-50 px-3 py-2 text-xs leading-5 text-accent-800"
        >
          {notice}
        </p>
      )}
    </div>
  );
}